/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseBannerBlockGroesse } from './DatabaseBannerBlockGroesse';
import {
    DatabaseBannerBlockGroesseFromJSON,
    DatabaseBannerBlockGroesseFromJSONTyped,
    DatabaseBannerBlockGroesseToJSON,
} from './DatabaseBannerBlockGroesse';
import type { DatabaseBannerHoehe } from './DatabaseBannerHoehe';
import {
    DatabaseBannerHoeheFromJSON,
    DatabaseBannerHoeheFromJSONTyped,
    DatabaseBannerHoeheToJSON,
} from './DatabaseBannerHoehe';
import type { DatabaseBannerKarten } from './DatabaseBannerKarten';
import {
    DatabaseBannerKartenFromJSON,
    DatabaseBannerKartenFromJSONTyped,
    DatabaseBannerKartenToJSON,
} from './DatabaseBannerKarten';
import type { DatabaseBannerStile } from './DatabaseBannerStile';
import {
    DatabaseBannerStileFromJSON,
    DatabaseBannerStileFromJSONTyped,
    DatabaseBannerStileToJSON,
} from './DatabaseBannerStile';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlock } from './DatabaseHeaderBlock';
import {
    DatabaseHeaderBlockFromJSON,
    DatabaseHeaderBlockFromJSONTyped,
    DatabaseHeaderBlockToJSON,
} from './DatabaseHeaderBlock';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';
import type { DatabaseSubDbListDisplay } from './DatabaseSubDbListDisplay';
import {
    DatabaseSubDbListDisplayFromJSON,
    DatabaseSubDbListDisplayFromJSONTyped,
    DatabaseSubDbListDisplayToJSON,
} from './DatabaseSubDbListDisplay';
import type { DatabaseSubDbListLayout } from './DatabaseSubDbListLayout';
import {
    DatabaseSubDbListLayoutFromJSON,
    DatabaseSubDbListLayoutFromJSONTyped,
    DatabaseSubDbListLayoutToJSON,
} from './DatabaseSubDbListLayout';
import type { DatabaseSubDbListSource } from './DatabaseSubDbListSource';
import {
    DatabaseSubDbListSourceFromJSON,
    DatabaseSubDbListSourceFromJSONTyped,
    DatabaseSubDbListSourceToJSON,
} from './DatabaseSubDbListSource';

/**
 * DERSELBE BAUSTEIN WIE AUF DER SEITE, nur im Kopf- oder Fussbereich.
 * 
 * WOFUER: Die Aktionsflaeche einer Anlage (Kiosk-Angebote, rotierend)
 * und die Werbung je Bahn stehen im Prototyp im KOPF und im FUSS — also
 * dort, wo sie auf JEDER Seite erscheinen. Ein Baustein, den es nur auf
 * der Seite gibt, muesste auf jeder Seite wiederholt werden; genau das
 * soll der Bereich ersparen.
 * 
 * Die Einstellungen sind dieselben wie beim Seiten-Baustein — bewusst,
 * damit niemand zweierlei lernen muss.
 * @export
 * @interface DatabaseSubDbListHeaderBlock
 */
export interface DatabaseSubDbListHeaderBlock extends DatabaseHeaderBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    childDatabaseId?: string;
    /**
     * 
     * @type {DatabaseSubDbListSource}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    source?: DatabaseSubDbListSource;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    fixedEntryId?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    fontSize?: DatabaseFontSizeEnum;
    /**
     * Was dasteht, wenn die Liste LEER ist. Ohne Angabe steht dort
     * nichts — so wie bisher, damit bestehende Vorlagen sich nicht
     * von selbst aendern.
     * 
     * WOFUER: Eine leere Liste ist sonst ein stummes Loch. Auf der
     * Minigolf-Karte blieb unter „Schlaege auf dieser Bahn" eine
     * halbe Seite leer, solange keine Mitspieler eingetragen waren
     * — ohne ein Wort, was zu tun ist. Der Satz gehoert dem
     * Betreiber, nicht dem Programm: Nur er weiss, warum seine
     * Liste leer sein kann.
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    emptyText?: string;
    /**
     * 
     * @type {DatabaseSubDbListDisplay}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    display?: DatabaseSubDbListDisplay;
    /**
     * 
     * @type {DatabaseSubDbListLayout}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    layout?: DatabaseSubDbListLayout;
    /**
     * 
     * @type {DatabaseBannerHoehe}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    hoehenModus?: DatabaseBannerHoehe;
    /**
     * 
     * @type {DatabaseBannerBlockGroesse}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    blockGroesse?: DatabaseBannerBlockGroesse;
    /**
     * 
     * @type {DatabaseBannerStile}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    bannerStile?: DatabaseBannerStile;
    /**
     * DIE ANORDNUNG JE DATENSATZ.
     * 
     * Bis hierher sass die Anordnung am BAUSTEIN — alle Eintraege
     * einer rotierenden Reihe sahen damit gleich aus. Die
     * Spezifikation der Scorecard verlangt aber sechs verschiedene
     * Banner im Wechsel: Preis-Kachel, Emoji-Zeile, Gruppen-Angebot,
     * Foto rechts, rundes Foto links, Abend-Veranstaltung.
     * 
     * Steht hier ein Feld, liest der Baustein die Anordnung JE
     * EINTRAG daraus. Der Wert muss einer der Namen aus
     * `DatabaseSubDbListLayout` sein; was nicht passt, faellt auf
     * `layout` zurueck. Ohne Angabe bleibt alles wie bisher.
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    layoutFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    badgeFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    titleFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    textFieldId?: string;
    /**
     * ZIELGRUPPE — die Zeile „FUER GRUPPEN & FAMILIEN" ueber der
     * Ueberschrift. Nur GRUPPEN_STACK zeigt sie.
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    zielgruppeFieldId?: string;
    /**
     * LABEL — die kleine Metazeile in Grossbuchstaben („SPAR-KOMBI",
     * „FR & SA AB 20:00 UHR"). GRUPPEN_STACK und EVENT_CARD.
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    labelFieldId?: string;
    /**
     * ICON — ein Zeichen oder Emoji links im Band. Nur ICON_EXPRESS.
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    iconFieldId?: string;
    /**
     * BUTTON — die Handlungsflaeche rechts („5,00 € ›", „Tickets ›",
     * „-10% Rabatt"). Sie ersetzt die frueher getrennte Rolle
     * „Preis": In der Vorlage des Betreibers ist der Preis genau
     * dieser Knopf.
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    buttonFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    priceFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    imageFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    popupFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    linkFieldId?: string;
    /**
     * Das Feld, dessen im Editor gestalteter Inhalt die Art
     * `FREIE_GESTALTUNG` ueber die ganze Flaeche zeigt.
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    gestaltungFieldId?: string;
    /**
     * 
     * @type {DatabaseBannerKarten}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    kartenAuswahl?: DatabaseBannerKarten;
    /**
     * NUR BEI `kartenAuswahl: AUSWAHL` — die NAMEN der Karten, auf
     * denen das Band erscheint („bei Auswahl Dropdown mit
     * Mehrfachauswahl", Betreiber 13.09.2026).
     * 
     * DER NAME, NICHT DIE KENNUNG: Eine Karte kann kopiert oder neu
     * angelegt werden; ihr Name ist das, was der Betreiber in der
     * Maske sieht und auswaehlt. Dieselbe Wahl wie beim
     * Anzeigefilter ueber den Seitennamen.
     * @type {Array<string>}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    karten?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    filterFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    filterValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    filterByFieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    sortFieldId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    sortDescending?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    maxItems?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    rotationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    fallbackEntryId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSubDbListHeaderBlock
     */
    showRank?: boolean;
}

/**
 * Check if a given object implements the DatabaseSubDbListHeaderBlock interface.
 */
export function instanceOfDatabaseSubDbListHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSubDbListHeaderBlockFromJSON(json: any): DatabaseSubDbListHeaderBlock {
    return DatabaseSubDbListHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseSubDbListHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbListHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'source': !exists(json, 'source') ? undefined : DatabaseSubDbListSourceFromJSON(json['source']),
        'fixedEntryId': !exists(json, 'fixedEntryId') ? undefined : json['fixedEntryId'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
        'emptyText': !exists(json, 'emptyText') ? undefined : json['emptyText'],
        'display': !exists(json, 'display') ? undefined : DatabaseSubDbListDisplayFromJSON(json['display']),
        'layout': !exists(json, 'layout') ? undefined : DatabaseSubDbListLayoutFromJSON(json['layout']),
        'hoehenModus': !exists(json, 'hoehenModus') ? undefined : DatabaseBannerHoeheFromJSON(json['hoehenModus']),
        'blockGroesse': !exists(json, 'blockGroesse') ? undefined : DatabaseBannerBlockGroesseFromJSON(json['blockGroesse']),
        'bannerStile': !exists(json, 'bannerStile') ? undefined : DatabaseBannerStileFromJSON(json['bannerStile']),
        'layoutFieldId': !exists(json, 'layoutFieldId') ? undefined : json['layoutFieldId'],
        'badgeFieldId': !exists(json, 'badgeFieldId') ? undefined : json['badgeFieldId'],
        'titleFieldId': !exists(json, 'titleFieldId') ? undefined : json['titleFieldId'],
        'textFieldId': !exists(json, 'textFieldId') ? undefined : json['textFieldId'],
        'zielgruppeFieldId': !exists(json, 'zielgruppeFieldId') ? undefined : json['zielgruppeFieldId'],
        'labelFieldId': !exists(json, 'labelFieldId') ? undefined : json['labelFieldId'],
        'iconFieldId': !exists(json, 'iconFieldId') ? undefined : json['iconFieldId'],
        'buttonFieldId': !exists(json, 'buttonFieldId') ? undefined : json['buttonFieldId'],
        'priceFieldId': !exists(json, 'priceFieldId') ? undefined : json['priceFieldId'],
        'imageFieldId': !exists(json, 'imageFieldId') ? undefined : json['imageFieldId'],
        'popupFieldId': !exists(json, 'popupFieldId') ? undefined : json['popupFieldId'],
        'linkFieldId': !exists(json, 'linkFieldId') ? undefined : json['linkFieldId'],
        'gestaltungFieldId': !exists(json, 'gestaltungFieldId') ? undefined : json['gestaltungFieldId'],
        'kartenAuswahl': !exists(json, 'kartenAuswahl') ? undefined : DatabaseBannerKartenFromJSON(json['kartenAuswahl']),
        'karten': !exists(json, 'karten') ? undefined : json['karten'],
        'filterFieldId': !exists(json, 'filterFieldId') ? undefined : json['filterFieldId'],
        'filterValue': !exists(json, 'filterValue') ? undefined : json['filterValue'],
        'filterByFieldId': !exists(json, 'filterByFieldId') ? undefined : json['filterByFieldId'],
        'sortFieldId': !exists(json, 'sortFieldId') ? undefined : json['sortFieldId'],
        'sortDescending': !exists(json, 'sortDescending') ? undefined : json['sortDescending'],
        'maxItems': !exists(json, 'maxItems') ? undefined : json['maxItems'],
        'rotationSeconds': !exists(json, 'rotationSeconds') ? undefined : json['rotationSeconds'],
        'fallbackEntryId': !exists(json, 'fallbackEntryId') ? undefined : json['fallbackEntryId'],
        'showRank': !exists(json, 'showRank') ? undefined : json['showRank'],
    };
}

export function DatabaseSubDbListHeaderBlockToJSON(value?: DatabaseSubDbListHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseHeaderBlockToJSON(value),
        'childDatabaseId': value.childDatabaseId,
        'source': DatabaseSubDbListSourceToJSON(value.source),
        'fixedEntryId': value.fixedEntryId,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
        'emptyText': value.emptyText,
        'display': DatabaseSubDbListDisplayToJSON(value.display),
        'layout': DatabaseSubDbListLayoutToJSON(value.layout),
        'hoehenModus': DatabaseBannerHoeheToJSON(value.hoehenModus),
        'blockGroesse': DatabaseBannerBlockGroesseToJSON(value.blockGroesse),
        'bannerStile': DatabaseBannerStileToJSON(value.bannerStile),
        'layoutFieldId': value.layoutFieldId,
        'badgeFieldId': value.badgeFieldId,
        'titleFieldId': value.titleFieldId,
        'textFieldId': value.textFieldId,
        'zielgruppeFieldId': value.zielgruppeFieldId,
        'labelFieldId': value.labelFieldId,
        'iconFieldId': value.iconFieldId,
        'buttonFieldId': value.buttonFieldId,
        'priceFieldId': value.priceFieldId,
        'imageFieldId': value.imageFieldId,
        'popupFieldId': value.popupFieldId,
        'linkFieldId': value.linkFieldId,
        'gestaltungFieldId': value.gestaltungFieldId,
        'kartenAuswahl': DatabaseBannerKartenToJSON(value.kartenAuswahl),
        'karten': value.karten,
        'filterFieldId': value.filterFieldId,
        'filterValue': value.filterValue,
        'filterByFieldId': value.filterByFieldId,
        'sortFieldId': value.sortFieldId,
        'sortDescending': value.sortDescending,
        'maxItems': value.maxItems,
        'rotationSeconds': value.rotationSeconds,
        'fallbackEntryId': value.fallbackEntryId,
        'showRank': value.showRank,
    };
}

